import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import TeacherSection from './components/TeacherSection';

const TeacherDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<div className="min-h-screen bg-gray-50">
			<nav className="bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-4 py-4">
					<div className="flex items-center justify-between">
						<button
							onClick={() => navigate('/')}
							className="flex items-center space-x-2 text-gray-700 hover:text-purple-600 transition-colors cursor-pointer"
						>
							<i className="ri-arrow-left-line text-xl"></i>
							<span className="font-bold text-xl">AIKnow 라이브 클래스</span>
						</button>
					</div>
				</div>
			</nav>
			<div className="max-w-7xl mx-auto px-4 py-24 -mt-20 relative z-10">
				<div className="bg-white rounded-3xl shadow-lg mb-8">
					<div className="p-8">
						<TeacherSection id={id} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default TeacherDetail;
